import instance from "@/services/api";

export const projectUspSendHandbookAPI = {
  async readHandbook(params) {
    return await instance()
      .get("/project_list/project/usp_send_handbook/read/", { params })
      .then((res) => res?.data);
  },
  async setEnabled(body) {
    return await instance()
      .post("/project_list/project/is_usp_send_enabled/set/", body)
      .then((res) => res?.data);
  },
  async getHistory(sbs_project_id) {
    return await instance()
      .get(`/project_list/project/usp_send_history/${sbs_project_id}/`)
      .then((res) => res?.data);
  },
  async getSbsProjects() {
    return await instance()
      .get("/common/sbs_projects/read/")
      .then((res) => res?.data);
  },
};
